import {Component, inject} from '@angular/core';
import {ImportModuleLookupSuggestion} from '../../../core/definitions/import-module';
import {usagesText} from '../column-usages';
import {ImportSessionStore, lookupSuggestionKey} from '../import-session.store';
import {LookupCodeEvent} from '../lookup-definitions/lookup-definitions.component';

/**
 * The Import module's Kodeoppslag tab: the lookups that read a value from
 * another table of the source by a code, each set up once and named by any
 * mapping row, each with its codes as the automatic check over the whole
 * file found them; and the column profile's suggested lookups for columns
 * that look like codes of another table.
 */
@Component({
  selector: 'app-import-lookups-step',
  templateUrl: './import-lookups-step.component.html',
  styleUrls: ['./import-lookups-step.component.scss'],
  standalone: false,
})
export class ImportLookupsStepComponent {
  readonly store: ImportSessionStore = inject(ImportSessionStore);
  readonly suggestionKey = lookupSuggestionKey;

  // The key of the lookup whose line is open; `null` while all are closed.
  expandedLookup: string | null = null;

  /** A new, empty lookup, opened. */
  add(): void {
    this.expandedLookup = this.store.addLookup().key;
  }

  /** A new lookup set up as `suggestion` says, opened. */
  accept(suggestion: ImportModuleLookupSuggestion): void {
    this.expandedLookup = this.store.acceptLookupSuggestion(suggestion).key;
  }

  meansBlank(event: LookupCodeEvent): void {
    this.store.lookupCodeMeansBlank(event.lookup, event.code);
  }

  /** The fields that read the suggestion's code column as it stands. */
  directUsages(suggestion: ImportModuleLookupSuggestion): string {
    const usages = this.store.usagesByColumn.get(suggestion.code_column) ?? [];
    return usagesText(usages.filter(usage => !usage.viaLookup));
  }
}
